import { render, staticRenderFns } from "./falls.vue?vue&type=template&id=f2e22490"
import script from "./falls.vue?vue&type=script&lang=js"
export * from "./falls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports